/** @format */

interface Options {
  token?: string;
  needSpaceBeforeToken?: boolean;
}

const getTokenWithSpace = ({token, needSpaceBeforeToken}: Options) => {
  if (!token) {
    return '';
  }
  return needSpaceBeforeToken ? ` ${token}` : token;
};

export default getTokenWithSpace;
